import { render, staticRenderFns } from "./candidatesModal.vue?vue&type=template&id=49797af0&"
import script from "./candidatesModal.vue?vue&type=script&lang=js&"
export * from "./candidatesModal.vue?vue&type=script&lang=js&"
import style0 from "./candidatesModal.vue?vue&type=style&index=0&id=49797af0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports